module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "cover"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "mb-2",
    class: {
      'issue-cancelled-card': _vm.issueCancelled || _vm.issueUnresolved, 'issue-resolved-card': _vm.issueResolved
    },
    attrs: {
      "header-text-variant": "dark",
      "border-variant": _vm.issueCancelled || _vm.issueUnresolved ? 'danger' : null,
      "header-border-variant": _vm.issueCancelled || _vm.issueUnresolved ? 'danger' : null
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('issues.reportIssueDetails'),
      "alternativeRoute": "issues/reported-issues"
    },
    scopedSlots: _vm._u([{
      key: "badges",
      fn: function(props) {
        return [_c('span', [(_vm.issueCancelled) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.2')))]) : _vm._e(), _vm._v(" "), (_vm.issueResolved) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.3')))]) : _vm._e(), _vm._v(" "), (_vm.issueUnresolved) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.4')))]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "6"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportId')
    }
  }, [_c('b-link', {
    staticClass: "property-label",
    attrs: {
      "to": _vm.resourceLink
    }
  }, [_vm._v(_vm._s(_vm.issueReport.resourceId))])], 1)], 1), _vm._v(" "), _c('b-col', [(_vm.issueActive) ? _c('b-img', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "report-image",
    attrs: {
      "title": _vm.$t('notifications.subscribe'),
      "right": "",
      "src": require("@/assets/images/notification-icon.svg")
    },
    on: {
      "click": _vm.subscribeToNotification
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportCategories')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueReport.categoryCyr))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportData')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueReport.data))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportColumnCreationDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.issueReport.creationDate)))])])], 1), _vm._v(" "), (_vm.issueReport.closingDate) ? _c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportColumnClosingDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.issueReport.closingDate)))])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.issueUser) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.issueUser) ? _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportIssueUserLogin')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueUser.login))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportIssueUserName')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueUser.name))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportIssueUserOrganization')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueUser.organizationName))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportUserComment')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueReport.userComment))])])], 1)], 1), _vm._v(" "), (_vm.issueReport.operatorComment) ? _c('div', [_c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportOperatorComment')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueReport.operatorComment))])])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "cancelIssueReportModal",
      "title": _vm.$t('issues.reportIssueCancelModal'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.cancelIssueReport
    }
  }, [_c('p', [_vm._v("\r\n            " + _vm._s(_vm.$t('issues.reportIssueCancelModalConfirm')) + "\r\n        ")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "resolveIssueReportModal",
      "title": _vm.$t('issues.reportIssueResolveModal'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": "",
      "size": "lg"
    },
    on: {
      "ok": _vm.resolveIssueReport
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.resolveIssueReport($event)
      }
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-form-group', {
    attrs: {
      "label": ""
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.resolveOptions,
      "stacked": "",
      "name": "radiosStacked"
    },
    model: {
      value: (_vm.resolveStatus),
      callback: function($$v) {
        _vm.resolveStatus = $$v
      },
      expression: "resolveStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-1 text-center"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resolveComment),
      expression: "resolveComment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "8",
      "placeholder": _vm.$t('issues.reportIssueResolveComment')
    },
    domProps: {
      "value": (_vm.resolveComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resolveComment = $event.target.value
      }
    }
  })])], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "subscribeToNotification",
    attrs: {
      "title": _vm.$t('notifications.title'),
      "ok-title": _vm.$t('notifications.apply'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.submitNotificationSubscription
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('notifications.selectNotificationType')
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.formattedNotificationTypes,
      "plain": "",
      "stacked": ""
    },
    model: {
      value: (_vm.selectedNotificationTypes),
      callback: function($$v) {
        _vm.selectedNotificationTypes = $$v
      },
      expression: "selectedNotificationTypes"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b62da23", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b62da23","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/home/issues/single-issue/single-issue.html
// module id = 782
// module chunks = 1